const CustomCheckbox = {
  mounted() {
    this.el.addEventListener('click', () => {
      this.el.querySelector('input[type=checkbox]').click()
    })
  }
}

export default { CustomCheckbox }
